import { render, staticRenderFns } from "./ScheduleStaff.vue?vue&type=template&id=3f5e3ab7&"
import script from "./ScheduleStaff.vue?vue&type=script&lang=js&"
export * from "./ScheduleStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5e3ab7')) {
      api.createRecord('3f5e3ab7', component.options)
    } else {
      api.reload('3f5e3ab7', component.options)
    }
    module.hot.accept("./ScheduleStaff.vue?vue&type=template&id=3f5e3ab7&", function () {
      api.rerender('3f5e3ab7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/ScheduleStaff.vue"
export default component.exports